import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingFallback = () => {
    return (
        <output
            className={'loading-fallback'}
        >
            <Spinner
                animation={'border'}>
                <span
                    className={'visually-hidden'}>Loading...</span>
            </Spinner>
        </output>
    );
};

export default LoadingFallback;